<template>
<q-page class="main">
  <q-card class="page-card">
    <q-card-section v-if="$isDesktop" class="page-card__main-content">
      <h1 class="heading-2 q-mb-lg">Inrichtingselementen</h1>
      <div class="row items-center justify-between">
        <div class="col-shrink">
          Kies een inrichtingselement uit de lijst.
        </div>
        <div class="col-shrink">
          <flat-button class="q-mr-md" icon="layers" label="Beheer subcategorie&euml;n"
                       @click="$goto('object-group.index')" />
        </div>
      </div>
    </q-card-section>
    <q-card-section>
      <common-banner v-if="!groupsExist" type="warning" class="q-mb-lg">
        Er zijn nog geen subcategorie&euml;n. Op dit moment kunnen er nog geen inrichtingselementen worden aangemaakt.
        <template v-slot:actions>
          <q-btn color="warning" text-color="text-base" unelevated no-caps @click="$goto('object-group.create')">
            Maak een subcategorie aan
          </q-btn>
        </template>
      </common-banner>
    </q-card-section>
    <q-card-section v-if="!$isDesktop" class="page-card__main-content">
      <h1 class="heading-2 q-pl-sm">Inrichtingselementen</h1>
      <object-index :objects="objects" class="q-mt-md" />
    </q-card-section>
  </q-card>
  <sticky-top-bar>
    <accent-button v-if="$can('create', 'structural_object')" label="Nieuw inrichtingselement"
                   @click="$goto('object.create')" :disabled="!groupsExist" />
  </sticky-top-bar>
  <sticky-bottom-bar v-if="!$isDesktop">
    <common-fab>
      <template v-slot:actions>
        <fab-action
            v-if="$can('create', 'structural_object') && groupsExist"
            icon="add"
            label="Nieuw inrichtingselement"
            @click="$goto('object.create')"
        />
        <fab-action
            icon="layers"
            label="Beheer subcategorie&euml;n"
            @click="$goto('object-group.index')"
        />
      </template>
    </common-fab>
  </sticky-bottom-bar>
</q-page>
</template>

<script>
import ObjectIndex from '~HIOR/components/sidebars/ObjectIndex'

export default {
  components: {
    ObjectIndex,
  },
  props: {
    groupsExist: {
      type: Boolean,
    },
    objects: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  computed: {
    categoriesCount () {
      return this.object.categories ? this.object.categories.length : null
    },
  },
}
</script>
